///<reference path="../../../../../../node_modules/@angular/core/src/metadata/ng_module.d.ts"/>
import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Currency} from '../currency';
import {CurrencyService} from '../currency.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import { AppArcComponent } from '../../../../components/app-arc';
import {YearsShowComponent} from "../../years/years-show/years-show.component";


@NgModule({
    imports: [CommonModule, FormsModule,MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        CurrenciesShowComponent
    ],
    entryComponents: [
        CurrenciesShowComponent
    ],
    exports: [],
    providers: [SharedService, CurrencyService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-currencies-show',
    templateUrl: './currencies-show.component.html',
    styleUrls: ['./currencies-show.component.scss'],
    providers: [CurrencyService, ConfirmationService, MessageService]
})

export class CurrenciesShowComponent implements OnInit, AfterViewInit {
    id: string;
    currency: Currency;
    applog: AppLogComponent;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() modelName;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent:any;
    statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];

    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _searchButton: any;
    private _printButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private currencyService: CurrencyService,
                public activeModal: NgbActiveModal,
                private modalService: NgbModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            { label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton' },
            { label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton' },
            { label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton' },
            { label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton' },
            { label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton' },
        ]);
        this.sharedservice.setModelName('');
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.currency;
        modalRef.componentInstance.rowId = '';

    }
    ngAfterViewInit() {
        if(!this.scrId) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');

            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/currencies/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteCurrency(this.currency);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/currencies']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/currencies/search']);
                });

            }
        }
    }

    ngOnInit() {

        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            letter_code: new FormControl({value: '', disabled: true}),
            status: new FormControl({value: '', disabled: true}),

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.currencyService.getById(this.id).subscribe(
                currency => {
                    this.id = currency.id;
                    this.currency = currency;
                    this.parent = this.currency.id;
                    this.form.patchValue({
                        id: currency.id,
                        name: currency.name,
                        letter_code: currency.letter_code,
                        status: currency.status,
                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.currencyService.getById(this.scrId).subscribe(
                currency => {
                    this.id = currency.id;
                    this.currency = currency;
                    this.form.patchValue({
                        id: currency.id,
                        name: currency.name,
                        letter_code: currency.letter_code,
                        status: currency.status,

                    });
                }, error => {
                    console.log(error);
                }
            );
        } if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.currencyService.getTrashedById(this.delId).subscribe(
                currency => {
                    this.id = currency.id;
                    this.currency = currency;
                    this.form.patchValue({
                        id: currency.id,
                        name: currency.name,
                        letter_code: currency.letter_code,
                        status: currency.status,

                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.currency = this.newData;
            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                letter_code: this.newData.letter_code,
                status: this.newData.status,

            });
        }
    }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.currencies.'+role) >= 0) {
            return true;
        }
        return false;
    }

    deleteCurrency(currency: Currency) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (currency) {
                    this.currencyService.delete(currency.id).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Delete completed')
                            });
                            setTimeout(()=> {
                                this.router.navigate(['/currencies']);
                            },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);

                        }
                    );
                }
            }
        });
    }

    recoverEdit(currency: Currency) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (currency) {
                    this.currencyService.update(currency).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/currencies/show', currency.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.currencyService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/currencies/list']);
                        }
                    );
                }
            }
        });
    }


    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    // this.changePicUrl();
                    return true;
                }
            };
            const modalRef = this.modalService.open(AppArcComponent, options);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.screenName = this.modelName;
        }
    }
    showHistory(row_id: string) {
        if (row_id) {
            const modalRef = this.modalService.open(AppLogComponent);
            modalRef.componentInstance.rowId = row_id;
            modalRef.componentInstance.refShow = CurrenciesShowComponent;

        }
    }


}



// WEBPACK FOOTER //
// ./src/app/views/setting/currencies/currencies-show/currencies-show.component.ts